import SEO from '../components/SEO';

export default function TermsConditionsPage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Terms & Conditions | Waybook"
        description="Read Waybook's Terms & Conditions to understand the rules and guidelines for using our travel planning platform."
        keywords="terms and conditions, user agreement, service terms, legal terms"
        canonicalUrl="https://www.waybook.me/terms-conditions"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Terms & Conditions',
          description: 'Terms & Conditions for Waybook',
          url: 'https://www.waybook.me/terms-conditions'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">Terms & Conditions</h1>
        
        <div className="prose max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-700">
              These Terms & Conditions (Terms) govern your access to and use of the Waybook
              mobile apps (iOS and Android) and website (collectively, the Service). By
              accessing or using the Service, you agree to be bound by these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">2. Eligibility & Accounts</h2>
            <p className="text-gray-700">
              You must be at least 13 years old to use Waybook. When creating an account,
              provide accurate information and keep your credentials confidential. You are
              responsible for all activities under your account.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">3. Acceptable Use</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>No unlawful, infringing, or harmful activities.</li>
              <li>No scraping, reverse engineering, or unauthorized access.</li>
              <li>No posting of content that is illegal, hateful, or violates others’ rights.</li>
              <li>No interference with network or platform integrity.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">4. Your Content</h2>
            <p className="text-gray-700">
              You retain ownership of content you upload to Waybook. You grant Waybook a
              worldwide, non‑exclusive, royalty‑free license to host, store, reproduce,
              modify, and display your content solely to operate, improve, and provide the
              Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">5. Intellectual Property</h2>
            <p className="text-gray-700">
              The Service, including software, design, and trademarks, is owned by Waybook
              or its licensors and protected by intellectual property laws. Except as
              expressly permitted, you may not use our IP without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Third‑Party Services</h2>
            <p className="text-gray-700">
              The Service may link to third‑party sites or integrate third‑party services.
              We are not responsible for their content, policies, or practices.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">7. Disclaimers</h2>
            <p className="text-gray-700">
              The Service is provided “as is” and “as available” without warranties of any
              kind, express or implied, including merchantability, fitness for a particular
              purpose, and non‑infringement, to the extent permitted by law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700">
              To the maximum extent permitted by law, Waybook will not be liable for any
              indirect, incidental, special, consequential, or punitive damages, or any loss
              of data, use, goodwill, or profits arising from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Termination</h2>
            <p className="text-gray-700">
              We may suspend or terminate access if you violate these Terms or if required
              by law. You may stop using the Service at any time.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">10. Changes to the Service & Terms</h2>
            <p className="text-gray-700">
              We may update the Service and these Terms. If changes are material, we will
              provide reasonable notice via the app or website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">Contact</h2>
            <p className="text-gray-700">Email: <a href="mailto:support@waybook.me">support@waybook.me</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
